import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box';
import './Work.css';
import insights from '../../Assets/Work/tcinsights.png';
import period from '../../Assets/period.svg';
import { Link } from 'react-router-dom';
import NavBar from "../Navbar";
import Footer from "../Footer";

function TruliaCareInsights() {
  return (
    <section>
      <NavBar />
      <Box className="filebox">

        <Row>
          <aside>
            <Col sm={1}>
              <Container style={{ height: '100%' }}>
            
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '120s' }}>TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights         TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights         TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights         TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights         TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights         TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          TruliaCare Insights          
              </div>
              </div>
              </div>
              </Container>
            </Col>
            <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
                <Container className="canteen-content">
                  <Row  className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                    <img
                      src={insights}
                      alt="insights"
                      className="img-fluid"
                      style={{ padding: '0px' }}
                    />
                  </Row>
                  <Row style={{ paddingBottom: "32px" }}>
                    <div style={{ display: 'flex' }}>

                      <h1>TruliaCare Insights</h1>
                      <img
                        src={period}
                        alt="period"
                        className="img-fluid"
                        style={{ marginLeft: '2px', paddingTop: '1%', verticalAlign: 'bottom' }}
                      />

                    </div>
                    <p className="content">TruliaCare Insights powered by Kratin is a cutting-edge AI and machine learning solution that analyses and identifies gaps in hospices and equips them to make informed decisions for patients in their final days.</p>
                  </Row>
                  <Row style={{ paddingBottom: "48px", fontFamily: 'Changa', fontSize: '1.2em' }} >
                    <Col sm={4} className="box-col">
                      <div style={{ border: "1px solid white", padding: '5%', height: '100%' }}>
                        <p className="box-head">MY ROLE</p>
                        <p className="box-p">Visual Design Intern, UI/UX, Testing</p>
                      </div>
                    </Col>


                    <Col sm={4} className="box-col">
                      <div style={{ border: "1px solid white", padding: '5%', height: '100%' }}>
                        <p className="box-head">TIMELINE</p>
                        <p className="box-p">October, 2021 - Ongoing</p>
                      </div>
                    </Col>
                    <Col sm={4} className="box-col">
                      <div style={{ border: "1px solid white", padding: '5%', height: '100%' }}>
                        <p className="box-head">TOOLS USED</p>
                        <p className="box-p">Figma, PhotoShop</p>
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ paddingBottom: "32px", paddingTop: "10px" }}>
                    <Col>
                      <hr></hr>

                      <div style={{ display: 'flex' }}>
                        <h2>IMPACT</h2>
                        <img
                          src={period}
                          alt="period"
                          className="img-fluid"
                          style={{ marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                        />
                      </div>
                      
                      <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content">01</p>
                        </Col>
                        <Col>
                          <p className="content"><b className="bold-content">Personalized Dashboard: </b>
                          Designed a personalized dashboard with well-thought key performance indicators (KPIs) for streamlined data access <b>saving 10% of analytical time.</b> </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content">02</p>
                        </Col>
                        <Col>
                          <p className="content"><b className="bold-content">Alerts and Goals: </b>
                          Conceptualized and incorporated alerts and goals into the dashboard to <b>help hospices achieve better outcomes</b> by addressing issues on time.</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content">03</p>
                        </Col>
                        <Col>
                          <p className="content"><b className="bold-content"><a href="https://ins01.truliacare.com/" rel="noopener noreferrer" target="_blank" style={{color: '#F9D63D'}}>Landing Page for TruliaCare Insights:</a> </b>
                             Collaborated to create a landing page that effectively communicated the product's benefits to potential users. </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content">04</p>
                        </Col>
                        <Col>
                          <p className="content"><b className="bold-content">Care Plan and Care Interventions: </b>
                          Automated the creation of personalized care plans and interventions to customize nursing visits and keep families up-to-date. Thus, <b>improving patient satisfaction.</b></p>
                        </Col>
                      </Row>
                      </Col>
                    </Row>
                    
                    <Row style={{ paddingBottom: "32px",}}>
                    <Col>

                      <hr></hr>
                      <div style={{ display: 'flex' }}>
                        <h2>LEARNINGS</h2>
                        <img
                          src={period}
                          alt="period"
                          className="img-fluid"
                          style={{ marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                        />
                      </div>
                      <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content">01</p>
                        </Col>
                        <Col>
                          <p className="content"><b className="bold-content">User-Centeric Design: </b>
                             Adapted to the new concept of hospice care that isn't prevalent in India.</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content">02</p>
                        </Col>
                        <Col>
                          <p className="content"><b className="bold-content">Visual Communication is Essential.</b> Sharing visual references and low-fidelity explorations when presenting ideas to cross-functional teams is beneficial. It helped me better communicate my design ideas and receive feedback from my peers.</p>
                        </Col>
                      </Row>
                      
                      <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content">03</p>
                        </Col>
                        <Col>
                          <p className="content"><b className="bold-content">Confidence in Design Abilities.</b> With experience, I have gained confidence in my design abilities. I can articulate the rationale behind my creative choices and am open to feedback to improve my work.</p>
                        </Col>
                      </Row>
                      
                    </Col>
                  </Row>

                  <Row style={{ marginBottom: "100px", paddingTop: "40px", fontFamily: 'Changa', fontSize: '1.2em' }}>
                    <Link to={'/experience/kratinportal'} style={{ textDecoration: 'none' }}>
                      <div className="button-work" style={{ border: "1px solid white", borderRadius: '5px', height: 'auto', width: '15%', color: 'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom: '10px', position: 'absolute', right: '0px' }}>
                        Next
                      </div>
                    </Link>
                  </Row>

                </Container>
              </Container>
            </Col>
          </aside>
        </Row>

        <Footer />
      </Box>
    </section>
  );
}

export default TruliaCareInsights;
